import React, { useContext, useEffect } from "react";
import * as Dati from "src/Dati";
import * as DatiFide from "src/DatiFide";
import * as Glob from "src/Globale";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import { Trad } from "src/components/";
import { _BondsRatesTab, _ButtonAPI, _TabbedForm } from "..";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

export interface IFideTassiProduct extends DatiFide.CDatiFideTassi {
    Index: number;
}

interface IBondsRatesFormProps {
    ID_Binder: string;
}

export const _BondsRatesForm: React.FC<IBondsRatesFormProps> = ({ ID_Binder }) => {
    const { ShowDialog } = useContext(AlertDialogContext);
    const [Data, setData] = useReducerOnChange<DatiFide.CRisAPIListaFideTassi>(new DatiFide.CRisAPIListaFideTassi());

    useEffect(() => {
        GetData();
    }, [ID_Binder]);

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/fidetassi/?id_binder=${ID_Binder}`,
            OnRis: OnGetData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetData = (sender: ChiamaWeb, data: DatiFide.CRisAPIListaFideTassi) => {
        if (data && data.Dati) {
            data.Dati = SortProducts(data.Dati);
        }

        setData({ Type: "Set", Value: data });
    };

    const GetFormData = (): Dati.CIngrAPILista<DatiFide.CDatiFideTassi> => {
        const formData = new Dati.CIngrAPILista<DatiFide.CDatiFideTassi>();
        formData.Dati = Data.Dati;

        return formData;
    };

    const SortProducts = (data: DatiFide.CDatiFideTassi[]): DatiFide.CDatiFideTassi[] =>
        data.sort((a, b) => a.ID_BinderCompagnia - b.ID_BinderCompagnia || a.ID_TipoProdotto - b.ID_TipoProdotto || a.SommaGarantitaDa - b.SommaGarantitaDa);

    const OnAddProduct = (lastItem: IFideTassiProduct) => {
        const newField = new DatiFide.CDatiFideTassi(
            lastItem.Compagnia,
            lastItem.ID_Binder,
            lastItem.ID_BinderCompagnia,
            lastItem.ID_TipoRamo,
            lastItem.ID_TipoProdotto,
            lastItem.ID_TipoDurata,
            lastItem.Durata,
            lastItem.TipoRamo,
            lastItem.TipoProdotto,
            lastItem.LimitePerSingoloProdotto,
            lastItem.LimiteTassoMinimo,
            lastItem.SommaGarantitaA,
            lastItem.LimitePerSingoloProdotto
        );
        let data = Data.Dati;

        data.push({ ...newField });
        data = SortProducts(data);
        setData({ Type: "OnChangeFromValue", Name: "Dati", Value: data });
    };

    const OnClickSave = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            const errorMessage = `${Trad.Trad(data.ErrTesto)}${data.ErrTesti.length ? `: ${data.ErrTesti[0]}` : ""}`;

            ShowDialog("ERRORE", errorMessage, "error");
        } else {
            ShowDialog("TASSI", Trad.Trad("Tassi salvati correttamente"), "success");
        }
    };

    const GetGroupedData = (): IFideTassiProduct[][] =>
        Data.Dati.reduce((total: any, current, index) => {
            let last = total[total.length - 1];

            if (!last || last[0].ID_BinderCompagnia !== current.ID_BinderCompagnia) {
                total.push([{ ...current, Index: index }]);
            } else {
                last.push({ ...current, Index: index });
            }

            return total;
        }, []);

    const groupedData = GetGroupedData();

    return groupedData.length > 0 ? (
        <_TabbedForm
            Actions={[
                <_ButtonAPI
                    Default
                    Attivo
                    Testo={Trad.Trad("Salva")}
                    URL="/api/fidetassi/"
                    OnInvio={GetFormData}
                    OnClick={OnClickSave}
                    OnErrore={OnApiError}
                    Hidden={!Glob.AzioneAbilitata("FideTassiController", Glob.Scrittura)}
                />
            ]}
            RenderTabContent={(index: number) => (
                <_BondsRatesTab
                    Products={groupedData[index]}
                    DurationTypes={Data.Tipi["TipiDurate"]}
                    OnAddProduct={OnAddProduct}
                    OnChange={(e, val) => setData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                />
            )}
            TabLabels={groupedData.map(group => group[0].Compagnia)}
        />
    ) : null;
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsRates/BondsRatesForm.tsx